import { render } from "./SectionContent.vue?vue&type=template&id=0bf6f1ce"
import script from "./SectionContent.vue?vue&type=script&lang=js"
export * from "./SectionContent.vue?vue&type=script&lang=js"

import "./SectionContent.vue?vue&type=style&index=0&id=0bf6f1ce&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__